import { render, staticRenderFns } from "./AppointmentFilesTable.vue?vue&type=template&id=dc5fdbb6"
import script from "./AppointmentFilesTable.vue?vue&type=script&lang=js"
export * from "./AppointmentFilesTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFilesTable.vue?vue&type=style&index=0&id=dc5fdbb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports